import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PootsyButton } from './DesignFunctions'
import { PootsyCheckboxInput, PootsyTextInput } from './InputsFunctions'

import * as actions from "../actions/acLogin"
import InputsChangeHandler from "./InputsChangeHandler";


class SignInForm extends Component {
	render() {

		let { t } = this.context

		return(
			<InputsChangeHandler onChange={this.handleFormChanges}>
				<div className="SignUpInForm">
					<div className="create-account-textinputs">
						<PootsyTextInput placeholder={t('email_input_placeholder')}
										 name="email"
										 label={t('email_input_label')}
										 value={this.props.data.email}
						/>
						<PootsyTextInput placeholder={t('password_input_placeholder')}
										 name="password"
										 type="password"
										 label={t('password_input_label')}
										 value={this.props.data.password}
										 secondaryLabel={this.renderSecondaryLabel()}
										 onKeyPress={this.handleSubmit}
						/>
					</div>
					<div className="create-account-remember">
						<PootsyCheckboxInput label={t('remember_me')}
											 name="remember_me"
						/>
					</div>
					<PootsyButton text={t('login')}
								  onClick={this.onLoginButtonClick}
								  disabled={!this.props.meta.canSubmit}
					/>
				</div>
			</InputsChangeHandler>
		)
	}

	renderSecondaryLabel = () => {
		let { t } = this.context
		return (
			<Link key="a" to="/auth/forgot-password" className="login-link" tabIndex={-1}>{t('forgot_password')}</Link>
		)
	}

	handleFormChanges = changes => {
		this.props.dispatch(actions.processDataChange(changes))
	}

	onLoginButtonClick = () => {
		this.props.dispatch(actions.sign_in())
	}

	handleSubmit = e => {
		if(e.key === 'Enter'){
			this.props.dispatch(actions.sign_in())
		}
	}
}

SignInForm.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	data: state.dataReducer.signin,
	meta: state.metadataReducer.signin
})

export default connect(mapStateToProps)(SignInForm);


// WEBPACK FOOTER //
// ./src/components/SignInForm.js